// '../types' is an untyped .js module; its constants resolve as `any`.
import * as Types from '../types';

interface ResultActionPayload {
  open: boolean;
  success: boolean;
  data: Record<string, unknown>;
  error: unknown;
  errorDetail: unknown;
}

interface ResultAction {
  type: string;
  payload: ResultActionPayload;
}

const createResultAction =
  (type: string) =>
    (
      open: boolean,
      success: boolean,
      data: Record<string, unknown> = {},
      error: unknown = null,
      errorDetail: unknown = null,
    ): ResultAction => ({
      type,
      payload: {
        open,
        success,
        data,
        error,
        errorDetail,
      },
    });

/* Custom Fields */
export function createCustomField(
  userId: string,
  costCenterId: string,
  productAccessId: string,
  label: string,
) {
  return {
    type: Types.CREATE_CUSTOM_FIELD,
    userId,
    costCenterId,
    productAccessId,
    label,
  };
}

export const createCustomFieldResult = createResultAction(Types.CREATE_CUSTOM_FIELD_RESULT);

export function updateCustomField(
  userId: string,
  costCenterId: string,
  productAccessId: string,
  referenceFields: unknown,
  id: string,
  payload: unknown,
) {
  return {
    type: Types.UPDATE_CUSTOM_FIELD,
    userId,
    costCenterId,
    productAccessId,
    referenceFields,
    id,
    payload,
  };
}

export const updateCustomFieldResult = createResultAction(Types.UPDATE_CUSTOM_FIELD_RESULT);

export function updateCustomFieldOrder(
  userId: string,
  costCenterId: string,
  productAccessId: string,
  fields: unknown,
) {
  return {
    type: Types.UPDATE_CUSTOM_FIELD_ORDER,
    userId,
    costCenterId,
    productAccessId,
    fields,
  };
}

export const updateCustomFieldOrderResult = createResultAction(
  Types.UPDATE_CUSTOM_FIELD_ORDER_RESULT,
);

export function updateCustomFieldValues(
  costCenterId: string,
  productAccessId: string,
  userId: string,
  fields: unknown,
  isAdmin = false,
  adminId: string | undefined = undefined,
) {
  return {
    type: Types.UPDATE_CUSTOM_FIELD_VALUES,
    costCenterId,
    productAccessId,
    userId,
    fields,
    isAdmin,
    adminId,
  };
}

export function updateCustomFieldValuesWithInvite(
  inviteId: string,
  costCenterId: string,
  productAccessId: string,
  userId: string,
  fields: unknown,
  isAdmin = false,
  adminId: string | undefined = undefined,
) {
  return {
    type: Types.UPDATE_CUSTOM_FIELD_VALUES_WITH_INVITE,
    inviteId,
    costCenterId,
    productAccessId,
    userId,
    fields,
    isAdmin,
    adminId,
  };
}

export function processPhantomInviteCustomFields(
  productName: string,
  phantomToUserValues: unknown,
  userId: string,
  costCenterId: string,
  productAccessId: string,
  fields: unknown,
) {
  return {
    type: Types.PROCESS_PHANTOM_INVITE_CUSTOM_FIELDS,
    productName,
    phantomToUserValues,
    userId,
    costCenterId,
    productAccessId,
    fields,
  };
}

export const updateUserCustomFieldValuesResult = createResultAction(
  Types.UPDATE_USER_CUSTOM_FIELD_VALUES_RESULT,
);

// Separate from updateUserCustomFieldValuesResult so a failed admin table edit isn't shown as a
// failed invite submit
export const updateInviteCustomFieldValuesResult = createResultAction(
  Types.UPDATE_CUSTOM_FIELD_VALUES_WITH_INVITE_RESULT,
);

export const updateAdminCustomFieldValuesResult = createResultAction(
  Types.UPDATE_ADMIN_CUSTOM_FIELD_VALUES_RESULT,
);

export function clearCustomFieldResults() {
  return {
    type: Types.CLEAR_CUSTOM_FIELD_RESULTS,
  };
}
